import React, { FC, useState, useEffect } from "react";
import { RouterParamType } from "@/model/navModel";
import { YhBox } from "@/components/YhBox";
import { Button } from "antd";
import "./index.css";
import { exportPDF } from "@/utils/exportPDF";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useDrodDetailModel } from "../drodDetailModel";
import { IDtpDetail } from "@/views/document/customs/dtpTypes";
import { IDtpMaterialDetail } from "@/views/document/customsClearance/dtpTypes";
import { enquiryService } from "@/views/document/customs/dtpService";
import { formatNum4, formatNum, momentFormat } from "@/utils/utils";

export const CustomsClearance: FC<RouterParamType> = (detailsInfo) => {
    const {
        editFormVal
    } = useDrodDetailModel(({ editFormVal }) => [editFormVal]);
    const { getTreeNodeName, getTreeNodeNameValue } = useDictModel(() => []);
    const [loading, setLoading] = useState<boolean>(false);  //导出pdf， 导出时隐藏审批标记
    const [formVal, setFormVal] = useState<IDtpDetail | null>(null);
    const [list, setList] = useState<IDtpMaterialDetail[]>([])
    const [currency, setCurrency] = useState<string>("")  //币种符号
    const auditFields: any = {}

    useEffect(() => {
        getDtpDetailOne()
    }, [])

    //获取一条数据
    const getDtpDetailOne = async () => {
        let { retData } = await enquiryService.one(editFormVal?.customsCode ?? "");
        let { details, auditFlag, ...params } = retData;
        setFormVal(params)
        let newList = (details ?? []).map(item => ({
            ...item,
            // amount: formatNum(+(item.num ?? 0) * +(item.price ?? 0))
        }))
        setList(newList);
        setCurrency(details?.[0]?.currency ?? "")
    }

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            loading={loading}
            onClick={() => {
                setLoading(true);
                setTimeout(() => {
                    exportPDF("报关单", "customs-pdf", () => {
                        setLoading(false);
                    })
                }, 1500);
            }}
        >导出PDF</Button>
    </>


    const classname = (type: 0 | 1 | undefined, str?: string) => {
        return 'c-audit' + (type === 1 ? ' c-li-finish ' : type === 0 ? ' c-li-close ' : " ") + (str ?? '')
    }
    const classnameTd = (type: 0 | 1 | undefined, str?: string) => {
        return 'c-audit' + (type === 1 ? ' c-td-finish ' : type === 0 ? ' c-td-close ' : " ") + (str ?? '')
    }
    const classnameGood = (type: 0 | 1 | undefined, str?: string) => {
        return 'c-audit' + (type === 1 ? ' c-goods-finish ' : type === 0 ? ' c-goods-close ' : " ") + (str ?? '')
    }

    return (
        <YhBox title={action} style={{ marginBottom: "75px" }} >
            {/* <div className="customs-pdf c-hover c-audit-flag" id="customs-pdf"> */}
            {formVal && <div className={`customs-pdf  ${loading ? "" : "c-audit-flag"}`} id="customs-pdf">
                <div className="c-header">
                    <span>中华人民共和国海关出口货物报关单</span>
                </div>
                <ul className="head-ul">
                    {/* <li className="w35 c-audit c-li-finish"> */}
                    <li className={classname(auditFields.prescoCode, "w35")}>
                        <span>预录入编号：</span>
                        {/* {formVal.prescoCode} */}
                    </li>
                    <li className={classname(auditFields.customsCode, "w35")}><span>海关编号：</span>
                        {/* {formVal.customsCode} */}
                    </li>
                    <li></li>
                    <li></li>
                </ul>
                <table className="c-table">
                    <tbody>
                        <tr>
                            <td className={classnameTd(auditFields.supplierName)}>
                                <b>境内发货人</b>({formVal.supplierCode})
                                <br />
                                <span>云湖春煜（天津）资产管理有限公司&nbsp;</span>
                                {/* <span>{formVal.supplierName}&nbsp;</span> */}
                            </td>
                            <td colSpan={2} className={classnameTd(auditFields.exitType)}>
                                <b>出境关别</b>
                                <br />
                                <span>{formVal.exitType}&nbsp;</span>
                            </td>
                            <td colSpan={2} className={classnameTd(auditFields.departureTime)}>
                                <b>出口日期</b>
                                <br />
                                <span>{momentFormat(formVal.departureTime as string, "YYYY-MM-DD")}&nbsp;</span>
                            </td>
                            <td colSpan={2} className={classnameTd(auditFields.declareTime)}>
                                <b>申报日期</b>
                                <br />
                                <span>{momentFormat(formVal.declareTime as string, "YYYY-MM-DD")}&nbsp;</span>
                            </td>
                            <td className={classnameTd(auditFields.recordVarchar)}>
                                <b>备案号</b>
                                <br />
                                <span>{formVal.recordVarchar}&nbsp;</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={classnameTd(auditFields.customerName)}>
                                <b>境外收货人</b>
                                <br />
                                <span>{formVal.customerName}&nbsp;</span>
                            </td>
                            <td colSpan={2} className={classnameTd(auditFields.shipmentType)}>
                                <b>运输方式</b>
                                <br />
                                <span>{getTreeNodeName(formVal.shipmentType)}&nbsp;</span>
                            </td>
                            <td colSpan={2} className={classnameTd(auditFields.voyageNumber)}>
                                <b>运输工具名称及航次号</b>
                                <br />
                                <span>{formVal.voyageNumber}&nbsp;</span>
                            </td>
                            <td colSpan={3} className={classnameTd(auditFields.deliveryNumber)}>
                                <b>提运单号</b>
                                <br />
                                <span>{formVal.deliveryNumber}&nbsp;</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={classnameTd(auditFields.supplierCode)}>
                                <b>生产销售单位</b>({formVal.supplierCode})
                                <br />
                                <span>云湖春煜（天津）资产管理有限公司&nbsp;</span>
                                {/* <span>{formVal.supplierName}&nbsp;</span> */}
                            </td>
                            <td colSpan={2} className={classnameTd(auditFields.supervisionMethod)}>
                                <b>监管方式</b>
                                <br />
                                <span>{getTreeNodeName(formVal.supervisionMethod)}&nbsp;</span>
                            </td>
                            <td colSpan={2} className={classnameTd(auditFields.exemptionType)}>
                                <b>征免性质</b>
                                <br />
                                <span>{getTreeNodeName(formVal.exemptionType)}&nbsp;</span>
                            </td>
                            <td colSpan={3} className={classnameTd(auditFields.licenseKey)}>
                                <b>许可证号</b>
                                <br />
                                <span>{formVal.licenseKey}&nbsp;</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={classnameTd(auditFields.saleCode)}>
                                <b>合同协议号</b>
                                <br />
                                <span>{formVal.saleRealCode}&nbsp;</span>
                            </td>
                            <td colSpan={2} className={classnameTd(auditFields.countryTrade)}>
                                <b>贸易国(地区)</b>
                                <br />
                                <span>{getTreeNodeName(formVal.countryTrade)}&nbsp;</span>
                            </td>
                            <td colSpan={2} className={classnameTd(auditFields.destinationCountry)}>
                                <b>运抵国(地区)</b>
                                <br />
                                <span>{getTreeNodeName(formVal.destinationCountry)}&nbsp;</span>
                            </td>
                            <td colSpan={2} className={classnameTd(auditFields.dischargingPort)}>
                                <b>指运港</b>
                                <br />
                                <span>{getTreeNodeName(formVal.dischargingPort)}&nbsp;</span>
                            </td>
                            <td className={classnameTd(auditFields.portDeparture)}>
                                <b>离境口岸</b>
                                <br />
                                <span>{getTreeNodeName(formVal.portDeparture)}&nbsp;</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={classnameTd(auditFields.packageType)}>
                                <b>包装种类</b>
                                <br />
                                <span>{formVal.packageType}&nbsp;</span>
                            </td>
                            <td className={classnameTd(auditFields.num)}>
                                <b>件数</b>
                                <br />
                                <span>{formVal.num}&nbsp;</span>
                            </td>
                            <td className={classnameTd(auditFields.roughWeight)}>
                                <b>毛重(千克)</b>
                                <br />
                                <span>{formVal.roughWeight}&nbsp;</span>
                            </td>
                            <td className={classnameTd(auditFields.suttle)}>
                                <b>净重(千克)</b>
                                <br />
                                <span>{formVal.suttle}&nbsp;</span>
                            </td>
                            <td className={classnameTd(auditFields.transactionType)}>
                                <b>成交方式</b>
                                <br />
                                <span>{getTreeNodeName(formVal.transactionType)}&nbsp;</span>
                            </td>
                            <td className={classnameTd(auditFields.freight)}>
                                <b>运费</b>
                                <br />
                                <span>{formVal.freight ? `${currency}/` : ""}{formVal.freight}&nbsp;</span>
                            </td>
                            <td className={classnameTd(auditFields.premium)}>
                                <b>保费</b>
                                <br />
                                <span>{formVal.premium ? `${currency}/` : ""}{formVal.premium}&nbsp;</span>
                            </td>
                            <td className={classnameTd(auditFields.incidentals)}>
                                <b>杂费</b>
                                <br />
                                <span>{formVal.incidentals}&nbsp;</span>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={9} className={classnameTd(auditFields.documentsNum)}>
                                <b>随附单证及编号</b>
                                <br />
                                <span>{formVal.documentsNum}&nbsp;</span>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={9} className={classnameTd(auditFields.labelNote)} style={{ paddingBottom: "15px" }}>
                                <b>标记唛码及备注</b>
                                <br />
                                <span>{formVal.labelNote}&nbsp;</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table className="cm-table">
                    <thead>
                        <tr>
                            <td>项号</td>
                            <td>商品编号</td>
                            <td>商品名称及规格型号</td>
                            <td>数量及单位</td>
                            <td>单价/总价/币制</td>
                            <td>原产国(地区)</td>
                            <td>最终目的国(地区)</td>
                            <td>境内货源地</td>
                            <td>征免</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            list && list.map((item, index) => (
                                <tr key={item.id} className="c-audit">
                                    <td>
                                        <span>{index + 1}</span>
                                        <br />
                                        <span>&nbsp;</span>
                                        <br />
                                        <span>&nbsp;</span>
                                    </td>
                                    <td className={classnameGood(auditFields[item.id + "CustomsCode" ?? ""])}>
                                        <span>{item.customsCode}</span>
                                        <br />
                                        <span>&nbsp;</span>
                                        <br />
                                        <span>&nbsp;</span>
                                    </td>
                                    <td className={classnameGood(auditFields[item.id + "MaterialName" ?? ""])}>
                                        <span>{item.materialName}</span>
                                        <br />
                                        <span>{item.customsEntry ?? " "}</span>
                                        <br />
                                        <span>&nbsp;</span>
                                    </td>
                                    <td className={classnameGood(auditFields[item.id + "Num" ?? ""])}>
                                        <span>&nbsp;</span>
                                        <br />
                                        <span>{item.num}</span>
                                        <br />
                                        <span>{item.unitName}&nbsp;</span>
                                    </td>
                                    <td className={classnameGood(auditFields[item.id + "Price" ?? ""])}>
                                        <span>{formatNum4(item.price)}</span>
                                        <br />
                                        <span>{formatNum(item.amount)}</span>
                                        <br />
                                        <span>{item.currency}</span>
                                    </td>
                                    <td className={classnameGood(auditFields[item.id + "OriginCountry" ?? ""])}>
                                        <span>{item.originCountry ?? " "}</span>
                                        <br />
                                        <span>&nbsp;</span>
                                        <br />
                                        <span>&nbsp;</span>
                                    </td>
                                    <td className={classnameGood(auditFields[item.id + "DestinationCountry" ?? ""])}>
                                        <span>{item.destinationCountry ?? " "}</span>
                                        <br />
                                        <span>&nbsp;</span>
                                        <br />
                                        <span>&nbsp;</span>
                                    </td>
                                    <td className={classnameGood(auditFields[item.id + "SourceSupply" ?? ""])}>
                                        <span>{item.sourceSupply ?? " "}</span>
                                        <br />
                                        <span>&nbsp;</span>
                                        <br />
                                        <span>&nbsp;</span>
                                    </td>
                                    <td className={classnameGood(auditFields[item.id + "ShallBe" ?? ""])}>
                                        <span>{item.shallBe ?? " "}</span>
                                        <br />
                                        <span>&nbsp;</span>
                                        <br />
                                        <span>&nbsp;</span>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={9}>
                                <div><b>特殊关系确认:</b>{formVal.relationshipAffirm}</div>
                                <div><b>价格影响确认:</b>{formVal.priceAffirm}</div>
                                <div><b>支付特许权使用费确认:</b>{formVal.payAffirm}</div>
                                {/* <div><b>公式定价确认:</b></div>
                                <div><b>暂定价格确认:</b></div> */}
                                <div><b>自报自缴:</b>{formVal.declareType}</div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={6}>
                                <div>
                                    <span><b>报关人员</b></span>
                                    <span><b>报关人员证号</b></span>
                                    <span><b>电话</b></span>
                                    <span><b>兹申明对以上内容承担如实申报、依法纳税之法律责任</b></span>
                                </div>
                                <div style={{ position: "relative" }}>
                                    <div className="seal-box"></div>
                                    <span><b>申报单位</b></span>
                                    <span><b>申报单位(签章)</b></span>
                                </div>
                            </td>
                            <td colSpan={3}>
                                <b>海关批注及签章</b>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>}
        </YhBox >
    )
}